import { ThisConnector } from '../../../../api/connector'
import { BaseApiResponse } from '../../../../api/shared'

interface DeleteSourceNameArgs {
  organizationUuid: string
  sourceNameId: string
}

export async function deleteSourceName(
  this: ThisConnector,
  { organizationUuid, sourceNameId }: DeleteSourceNameArgs
) {
  return this.connector.executeDelete<BaseApiResponse>(
    `/${organizationUuid}/protect/sourcename/${sourceNameId}`
  )
}
